
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/noticias-recentes/todas",
      function () {
        return require("private-next-pages/noticias-recentes/todas/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/noticias-recentes/todas"])
      });
    }
  